<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editDevice" ref="editDeviceRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="editDevice.jigouid" :propsjigouname="editDevice.jigouname" @change="changeRsljigou"></Rsljigou>
            <el-button type="danger" plain @click="editDeviceUnbind">一键解绑所有用户</el-button>
          </el-form-item>
          <el-form-item label="批次号" class="addAdminForm">
            <el-input v-model="editDevice.batchno" placeholder="请输入批次号"></el-input>
          </el-form-item>
          <el-form-item label="MAC地址" class="addAdminForm">
            <el-input v-model="editDevice.mac" placeholder="请输入MAC地址"></el-input>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input v-model="editDevice.cardnumber" placeholder="请输入保修卡号"></el-input>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="editDevice.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售类型">
            <el-select v-model="editDevice.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产商" class="addAdminForm">
            <el-input v-model="editDevice.producename" placeholder="请输入生产商"></el-input>
          </el-form-item>
          <el-form-item label="生产日期" class="addAdminForm">
            <el-date-picker v-model="editDevice.producetime" type="date" placeholder="生产日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  data () {
    return {
      bomSnList: [],
      saleTypeList: [],
      editDevice: {
        jigouid: '0',
        jigouname: '',
        batchno: '',
        mac: '',
        cardnumber: '',
        bomsn: '',
        saletype: '0',
        producename: '',
        producetime: ''
      },
      parentdata: null
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.editDevice.jigouid = this.parentdata.params.Jigouid
      this.editDevice.jigouname = this.parentdata.params.Jigouname
      this.editDevice.batchno = this.parentdata.params.Batchno
      this.editDevice.mac = this.parentdata.params.Mac
      this.editDevice.cardnumber = this.parentdata.params.Cardnumber
      this.editDevice.bomsn = this.parentdata.params.Bomsn
      this.editDevice.saletype = this.parentdata.params.Saletype.toString()
      this.editDevice.producename = this.parentdata.params.Producename
      this.editDevice.producetime = this.parentdata.params.Producetime
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apieditDevice()
    },
    changeRsljigou (vid, vname) {
      this.editDevice.jigouid = vid
      this.editDevice.jigouname = vname
    },
    editDeviceUnbind () {
      this.apiEditDeviceUnbind()
    },
    apieditDevice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassid: that.parentdata.params.glassid,
        jigouid: that.editDevice.jigouid,
        batchno: that.editDevice.batchno,
        mac: that.editDevice.mac,
        cardnumber: that.editDevice.cardnumber,
        bomsn: that.editDevice.bomsn,
        saletype: that.editDevice.saletype,
        producename: that.editDevice.producename,
        producetime: that.editDevice.producetime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDevice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditDeviceUnbind: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassid: that.parentdata.params.glassid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDeviceUnbind, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
